import { render, staticRenderFns } from "./Fkdialog.vue?vue&type=template&id=5a7ae52f&scoped=true"
import script from "./Fkdialog.vue?vue&type=script&lang=js"
export * from "./Fkdialog.vue?vue&type=script&lang=js"
import style0 from "./Fkdialog.vue?vue&type=style&index=0&id=5a7ae52f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ae52f",
  null
  
)

export default component.exports